export default {"src":"/_next/static/media/songwriter.f894964b.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};